var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-8"},[(_vm.loading)?_c('loading-spinner'):[(_vm.step == 0)?_c('survey-intro'):(!_vm.is_active)?_c('profile-form'):_c('survey-container')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }